<template>
    <main>
      <div class="first-screen">
          <div class="container d-none d-lg-flex position-relative align-items-center justify-content-between">
            <div class="p-3 d-flex justify-content-center mb-auto">
              <img src="/static/main/logo.svg" alt="logo">
            </div>
            <section class="courses-block" id="courses_block-desc" data-bs-toggle="collapse" data-bs-target="#collapseCourses" aria-expanded="false" aria-controls="collapseCourses" style="margin-bottom: -13px;">
                  <div>
                      <div class="courses-toggle w-100 mb-auto">
                          <div class="green_bg rounded-pill mx-auto align-items-center px-3 py-2" style="width: fit-content;">
                              <div class="d-flex justify-content-between align-items-center gap-3 flex-wrap">
                                  <div class="d-flex align-items-center gap-3">
                                      <span>1 USDT = {{ format(USDT2RUB) }} RUB</span>
                                      <span>1 USDT = {{ format(USDT2EUR) }} EUR</span>
                                      <span>1 BTC = {{ format(BTC2USDT) }} USDT</span>
                                  </div>
                              </div>
                          </div>
                          <div class="text-center mx-auto" style="width: fit-content;">
                              <span class="text-black cursor-pointer bg-acidgreen rounded-pill px-3 py-1 d-block" style="margin-top:-3px;">Все курсы <img src="/img/shevron.svg" class="ms-1 arrow"></span>
                          </div>
                      </div>
                  </div>
            </section>
          <div class="d-flex justify-content-end" style="width: 178px">
            <router-link exact class="d-flex align-items-center gap-2 mb-auto" to="/login" v-if="!user || user.length == 0">
              <img src="/static/img/box-arrow-right.svg">
              <span class="text-white">Вход</span>
            </router-link>
            <router-link exact class="d-flex align-items-center gap-2 mb-auto" to="/actives" v-else>
              <img src="/static/img/box-arrow-right.svg">
              <span class="text-white">Вход</span>
            </router-link>
          </div>
        </div>
              <div class="w-100 collapse hide" id="collapseCourses">
                <div class="courses-expanded rounded rounded-4 p-4 mx-auto">
                    <div class="row">
                        <div class="col mb-4 mb-lg-0">
                            <div class="d-flex flex-column gap-3">
                                <div class="currency-pair" v-for="pair in fiatPairs" :key="pair.label">
                                    <div class="d-flex gap-3 text-nowrap">
                                        <span class="pair-title fz-16">USDT</span>
                                            <span class="text-success"> <img src="/static/img/courses/buy.svg"> {{ format(pair.buy) }} {{ pair.label }}</span>
                                            <span class="text-danger ms-2"> <img src="/static/img/courses/sell.svg"> {{ format(pair.sell) }} {{ pair.label }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md">
                            <div class="d-flex flex-column gap-3">
                                <div class="crypto-rate border-0" v-for="crypto in cryptoPairs" :key="crypto.label">
                                    <span class="fz-16 d-flex align-items-center gap-2">1 {{ crypto.label}} <img src="/static/img/ico/ico-history-convert-2.svg" width="44" height="8"> {{ format(crypto.value) }} USDT</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>



        <section class="courses-block d-block d-lg-none" id="courses_block">
          <div class="container">
              <!-- Новая вёрстка для главной -->
              <div>
                  <div class="courses-toggle w-100 mb-auto" data-bs-toggle="collapse" data-bs-target="#collapseCoursesM" aria-expanded="false" aria-controls="collapseCoursesM">
                      <div class="green_bg rounded-pill mx-auto align-items-center px-3 py-2 w-100">
                              <div class="d-flex align-items-center justify-content-center gap-2 gap-sm-3 mob-curses">
                                  <span>1 USDT = {{ format(USDT2RUB) }} RUB</span>
                                  <span>1 USDT = {{ format(USDT2EUR) }} EUR</span>
                                  <span>1 BTC = {{ format(BTC2USDT) }} USDT</span>
                              </div>
                      </div>
                      <div class="text-center mx-auto" style="width: fit-content;">
                          <span class="text-black cursor-pointer bg-acidgreen rounded-pill px-3 py-1 d-block mob-all-courses" style="margin-top:-3px;">Все курсы <img src="/img/shevron.svg" class="ms-1 arrow"></span>
                      </div>
                  </div>
  
              </div>
              <div class="w-100 collapse hide" id="collapseCoursesM">
                  <div class="courses-expanded rounded rounded-4 mt-2 p-4 mx-auto">
                      <div class="row">
                          <div class="col mb-4 mb-lg-0" style="max-width:fit-content">
                              <div class="d-flex flex-column gap-3">
                                  <div class="currency-pair" v-for="pair in fiatPairs" :key="pair.label">
                                      <div class="d-flex gap-2 gap-sm-3 text-nowrap">
                                          <span class="pair-title fz-16">USDT</span>
                                              <span class="text-success"> <img src="/static/img/courses/buy.svg"> {{ format(pair.buy) }} {{ pair.label }}</span>
                                              <span class="text-danger ms-2"> <img src="/static/img/courses/sell.svg"> {{ format(pair.sell) }} {{ pair.label }}</span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div class="col-12 col-md">
                              <div class="d-flex flex-column gap-3">
                                  <div class="crypto-rate border-0" v-for="crypto in cryptoPairs" :key="crypto.label">
                                      <span class="fz-16 d-flex align-items-center gap-2">1 {{ crypto.label}} <img src="/static/img/ico/ico-history-convert-2.svg" width="44" height="8"> {{ format(crypto.value) }} USDT</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
          </div>
      </section>

          <!-- Hero Section -->
          <section class="text-start text-md-center py-6 title-section">
            <div class="container">
              <div class="row">
                <div class="col-lg-6">
                  <div class="row">
                    <div class="col-12 text-start">
                      <h1 class="display-5 fw-extrabold gradient-text mb-4 mine-title">Твой универсальный инструмент в мире <span class="text-green">финансов</span></h1>
                    </div>
                  </div>
                  <div class="col-12 col-xs-10 col-md-8 text-start mb-3">
                    <p class="span">Международные платежи, оплата сервисов, криптооперации — все в <span class="text-green">криптобанке</span> Valutix</p>
                  </div>
                    <router-link v-if="!user || user.length == 0" exact class="button myBtn rounded-pill bg-acidgreen-imp acid_border w-fit mw-100 px-6 me-auto d-none d-sm-flex"  to="/registration">Регистрация</router-link>
                </div>
                <div class="col-lg-6">
                  <div class="rounded rounded-4 change_block text-start mb-4">
                    <h5 class="h5 mb-4">Обменять</h5>
                    <div class="d-flex gap-3 flex-wrap flex-xl-nowrap change_block_inner">

                      <div class="mb-md-0 w-mob-100">
                        <label for="exampleFormControlInput1" class="form-label">Сумма</label>
                        <div class="input-group">
                          <input type="number" class="form-control bg-transparent border-opacity-green shadow-none text-white" id="exampleFormControlInput1" v-model="amount" :max="maxAmount" @input="onAmountInput">
                          <span class="input-group-text bg-transparent text-white-50">{{ selectedFromCurrency }}</span>
                        </div>
                      </div>
                      <div class="d-flex gap-2 flex-lg-nowrap w-100">
  
                        <div class="mb-md-0 w-100">
                          <label for="select-from" class="form-label">Отдаю</label>
                        <div class="position-relative">
                        <v-select
                        :options="fromOptions"
                        label="label"
                        class="cursor-pointer text-black bg-transparent"
                        :reduce="currency => currency.value"
                        v-model="selectedFromCurrency"
                        :option-height="40"
                        :searchable="false"
                        :clearable="false"
                        >
                        <template #option="option">
                            <img :src="option.flag" width="24" />
                            {{ option.label }}
                        </template>
                        <template #selected-option="option">
                            <img :src="option.flag" width="24" />
                            {{ option.label }}
                        </template>
                        </v-select>
                          </div>
                        </div>
                          <!-- Кнопка смены валют -->
                          <div class="cursor-pointer mt-auto mb-2">
                            <img src="/img/ico/ico-convert--big.svg" @click="swapCurrencies">
                          </div>
                        <div class="mb-md-0 w-100">
                          <label for="select-to" class="form-label">Получаю</label>
                          <div>
                              <v-select
                              :options="toOptions"
                              label="label"
                              class="cursor-pointer text-black bg-transparent"
                              :reduce="currency => currency.value"
                              v-model="selectedToCurrency"
                              :option-height="40"
                              :searchable="false"
                              :clearable="false"
                              >
                              <template #option="option">
                                  <img :src="option.flag" width="24" />
                                  {{ option.label }}
                              </template>
                              <template #selected-option="option">
                                  <img :src="option.flag" width="24" />
                                  {{ option.label }}
                              </template>
                              </v-select>
                          </div>
                        </div>

                        
                      </div>

                    </div>

                    <div class="d-flex justify-content-between align-items-center flex-wrap flex-sm-nowrap gap-5 gap-sm-1">
                      <div class="text-white exchange-info">
                        <div class="fs-5 mb-1 exchange-eq">
                          <span class="exchange-left">{{ formatNumber(amount) }} {{ selectedFromCurrency }} =&nbsp;</span>
                          <span class="exchange-right">{{ (amount * (currentRate)) < 0.01 && (amount * (currentRate)) > 0 ? '< 0.01' : formatNumber(amount * (currentRate)) }} {{ selectedToCurrency }}</span>
                        </div>
                        <div class="small">1 {{ selectedFromCurrency }} = {{ (currentRate) < 0.01 && (currentRate) > 0 ? '< 0.01' : formatNumber(currentRate) }} {{ selectedToCurrency }}</div>
                        <div class="small">1 {{ selectedToCurrency }} = {{ (1/currentRate) < 0.01 && (1/currentRate) > 0 ? '< 0.01' : formatNumber(1/currentRate) }} {{ selectedFromCurrency }}</div>
                      </div>
                      <button class="button myBtn rounded-pill bg-transparent border_green acid_text px-6 w-fit mw-100" @click="handleExchange">Обменять</button>
                    </div>
                  </div>
                  <router-link v-if="!user || user.length == 0" exact class="button myBtn rounded-pill bg-acidgreen acid_border w-fit mw-100 px-6 me-auto d-flex d-sm-none"  to="/registration">Регистрация</router-link>
                  <router-link v-if="!user || user.length == 0" exact class="button myBtn rounded-pill bg-transparent acid_border acid_text mt-3 w-fit mw-100 px-6 mx-auto d-flex d-sm-none"  to="/login">Войти</router-link>
                  <router-link exact class="button myBtn rounded-pill bg-transparent acid_border acid_text mt-3 w-fit mw-100 px-6 mx-auto d-flex d-sm-none"  to="/actives" v-else >Войти</router-link>
                </div> 
              </div>

            </div>
          </section>
        
          <!-- Features Section -->
          <section class="py-6 swiper-section">
            <div class="container">
             <MySwiper/>
            </div>
          </section>
        
          <!-- Bank Section -->
          <section class="py-6 banks-section">
            <div class="container text-start">
              <h2 class="mb-4 h2">Криптобанк <span class="text-green">VALUTIX</span></h2>
              <div class="row mb-5">
                <div class="col col-md-5">
                  <span class="span">Наша система поддерживает широкую сеть платёжных решений, обеспечивая свободу действий и простоту в любых операциях.</span>
                </div>
              </div>
            </div>

              <div class="marquee-container mb-4 d-none d-sm-block">
                <div class="marquee-track">
                  <div 
                    v-for="(card, index) in duplicatedCards" 
                    :key="index"
                    class="marquee-item"
                  >
                    <img :src="card.image" style="max-width:150px; max-height:40px; width:100%; object-fit:contain"/>
                  </div>
                </div>
              </div>
              <div class="marquee-container mb-4 d-none d-sm-block">
                <div class="marquee-track-reverse">
                  <div 
                    v-for="(card, index) in duplicatedCards" 
                    :key="'second-' + index"
                    class="marquee-item"
                  >
                    <img :src="card.image" style="max-width:150px; max-height:40px; width:100%; object-fit:contain"/>
                  </div>
                </div>
              </div>
              <div class="marquee-container d-none d-sm-block">
                <div class="marquee-track">
                  <div 
                    v-for="(card, index) in duplicatedCards" 
                    :key="index"
                    class="marquee-item"
                  >
                    <img :src="card.image"  style="max-width:150px; max-height:40px; width:100%; object-fit:contain"/>
                  </div>
                </div>
              </div>

              <div class="d-block d-sm-none">
                <div class="container">
                  <div class="row g-2">
                    <div class="col-4" v-for="(card, index) in banks" :key="index">
                      <div class="rounded-3 bg_green p-1 d-flex justify-content-center align-items-center" style="height:34px">
                        <img :src="card.image" style="max-width:80px; max-height:22px; width:100%; object-fit:contain"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </section>
        </div>   
          <div class="second-screen rounded-4">
            <!-- Card Section -->
            <section class="mb-5 section-cards">
              <div class="container text-center">
                <h2 class="h2"><span class="text-green">VALUTIX</span> Card</h2>
                <p class="mb-5 span">Виртуальные карты с поддержкой Apple Pay</p>
                <div class="row gy-4">
                  <div class="col-12 col-md-4" v-for="(card, index) in cards" :key="index">
                    <div class="card border-0 rounded-4 d-flex flex-column justify-content-end p-3 text-start bold-18" :style="`background-image: url(${card.image})`">
                      <span class="fw-bold">{{ card.desc }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <!-- How to Start Section -->
            <section class="how-start-section">
              <div class="container text-center">
                <h2 class="h2" style="margin-bottom:38px">Как начать?</h2>
                <div class="row gy-4 text-start">
                  <div class="col-12 col-sm-6 col-lg-3">
                    <div class="how-card bg-black bg-opacity-10 rounded-4 py-3 p-4 d-flex flex-column gap-2 bold-500-18  lh-normal h-100">
                      <span>1</span>
                      <span class="">Зарегистрируйтесь в личном кабинете Valutix.</span>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-lg-3">
                    <div class="how-card bg-black bg-opacity-10 rounded-4 py-3 p-4 d-flex flex-column gap-2 bold-500-18  lh-normal h-100">
                      <span>2</span>
                      <span class="">Выпустите виртуальную карту за 5 USDT.</span>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-lg-3">
                    <div class="how-card bg-black bg-opacity-10 rounded-4 py-3 p-4 d-flex flex-column gap-2 bold-500-18  lh-normal h-100">
                      <span>3</span>
                      <span class="">Привяжите карту к Apple Pay</span>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-lg-3">
                    <div class="how-card bg-black bg-opacity-10 rounded-4 py-3 p-4 d-flex flex-column gap-2 bold-500-18 lh-normal h-100">
                      <span>4</span>
                      <span class="">Пополните баланс и используйте карту по всему миру.</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <section class="py-6 about-card-section">
            <div class="container">
              <div class="row gy-4">

                <div class="col-12 col-md-6">
                  <div class="card border-0 rounded-4 overflow-hidden w-100 about-card d-flex flex-column justify-content-between">
                    <div class="row py-2">
                      <div class="col-12 col-lg-6">
                        <h2 class="m-0 lh-1 h2">Дебетовые <br> карты Visa</h2>
                      </div>
                      <div class="col-12 col-lg-6 d-flex">
                        <span class="fz-18 fw-500 mt-3 mt-lg-auto">Именная пластиковая карта иностранного банка</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 mt-auto">
                        <div class="mb-1 d-flex flex-column">
                          <span class="text-green">Доставка </span>
                          <span class="fs-4 fw-bold">от 5 дней</span>
                        </div>
                        <div class="d-flex flex-column">
                          <span class="text-green">Стоимость карты</span>
                          <span class="fs-4 fw-bold">490 USDT</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="card border-0 rounded-4 overflow-hidden w-100 p-3 about-card-2 d-flex justify-content-center align-items-center">
                    <picture>
                      <source media="(min-width:500px)" srcset="/static/main/card.png">
                      <img src="/static/main/mobile-version/mobile.png" class="object-fit-contain card-img">
                    </picture>

                  </div>
                </div>

              </div>
            </div>
          </section>
        
          <!-- ramp Section -->
          <section class="py-6 text-center on-ramp-section">
            <div class="container">
              <h2 class="h2 text-start text-md-center">Решения <span class="text-green">от VALUTIX</span></h2>
              <div class="bg_darkgreen rounded-4 pt-5 fs-5 mb-4">
                <div class="row">
                  <div class="col-5 col-md-2 ms-auto d-flex flex-column justify-content-between align-items-center cursor-pointer" :class="onRamp == true ? 'text-green fw-bold' : ''" @click="onRamp = true">
                    <span>On-ramp</span>
                    <span class="under rounded mt-2 mt-md-4" v-if="onRamp === true"></span>
                  </div>
                  <div class="col-5 col-md-2 me-auto d-flex flex-column justify-content-between align-items-center cursor-pointer" :class="onRamp == false ? 'text-green fw-bold' : ''" @click="onRamp = false">
                    <span>Off-ramp</span>
                    <span class="under rounded mt-2 mt-md-4" v-if="onRamp !== true"></span>
                  </div>
                </div>
              </div>

                <div class="row text-start gy-4" v-show="onRamp === true">
                  <div class="col-12 col-lg-6">
                    <div class="rounded-4 w-100 bg_green p-4 p-sm-5">
                      <h2 class="mb-4 h2">On-ramp</h2>
                      <div class="row">
                        <div class="col-12 col-md-10">
                          <p>Удобный и понятный интерфейс поможет пользователю провести оплату счёта в "два клика".</p>
                          <p>Возможность оплаты зарубежных сервисов и товаров</p>
                          <p class="m-0">White label - наша разработка - ваш продукт</p>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="col-12 col-lg-6">
                    <img src="/static/main/onramp.svg" alt="off-ramp" width="636" height="487">
                    <!-- <div class="rounded-4 w-100 bg_darkgreen p-40">
                      <img src="/static/main/on-ramp.png" alt="on-ramp" width="541" height="475">
                    </div> -->
                  </div>
                </div>

                <div class="row text-start gy-4" v-show="onRamp !== true">
                  <div class="col-12 col-lg-6">
                    <div class="rounded-4 w-100 bg_green p-4 p-sm-5">
                      <h2 class="mb-4 h2">Off-ramp</h2>
                      <div class="row">
                        <div class="col-12 col-md-10">
                          <p>Удобный и понятный интерфейс поможет пользователю провести вывод средств в "два клика".</p>
                          <p>Выгодные условия офера</p>
                          <p class="m-0">Рассчёты в криптовалюте с платформой по договорённости 1-2 раза в неделю</p>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="col-12 col-lg-6">
                    <img src="/static/main/offramp.svg" alt="off-ramp" width="636" height="487">
                    <!-- <div class="rounded-4 w-100 bg_darkgreen p-40">
                      <img src="/static/main/off-ramp.png" alt="off-ramp" width="546" height="400">
                    </div> -->
                  </div>
                </div>
              </div>
          </section>

          <section class="mb-4">
            <div class="container">
                <div class="rounded-4 p-40 text-center shop-block">
                    <h2 class="mb-3 h2 little-h2"><span class="text-green">VALUTIX</span> Shop</h2>
                    <span class="display-1 fw-bold mb-4 d-block">Coming Soon</span>
                    <div class="row">
                      <div class="col-12 col-sm-8 mx-auto text-start text-sm-center">
                        <span>Ожидайте запуск нового раздела Valutix Shop, который предоставит пользователям удобные и выгодные способы пополнения различных сервисов и платформ.​</span>
                      </div>
                    </div>
                </div>
            </div>
          </section>

          <section class="coming-section mb-5">
            <div class="container">
              <div class="row gy-4">
                <div class="col-12 col-lg-6">
                    <div class="card p-40 border-0 rounded-4 bg-transparent d-flex coming-section-item-1">
                      <div class="row mt-auto">
                        <div class="col-12">
                          <span class="bold-18">Пополнение игровых <br> и цифровых платформ</span>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="card p-40 border-0 rounded-4 bg-transparent d-flex flex-column pt-4 coming-section-item-2">
                    <span class="badge rounded-pill bg-dark px-4 py-3 text-green fw-normal fs-6" style="width:fit-content">Комиссия 3%</span>
                    <img src="/static/main/mobile-version/steam.png" width="82px" height="82px" class="d-block d-sm-none">
                    <div class="row g-2 flex-column mt-auto">
                      <div class="col-12">
                        <span class="bold-18">Мгновенное <br> пополнение Steam</span>
                      </div>
                      <div class="col-12 col-sm-8">
                        <span>Пополнение баланса <br class="d-block d-xs-none"> осуществляется в USDT. 
                          Средства зачисляются на ваш аккаунт в течение нескольких минут.</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="card p-40 border-0 rounded-4 bg-transparent d-flex coming-section-item-3">
                    <div class="row g-2 flex-column mt-auto">
                      <div class="col-12">
                        <img src="/static/main/mobile-version/sim.png" width="160" height="160" class="d-block d-sm-none">
                        <span class="bold-18 d-block">Оплата услуг <br class="d-block d-xs-none"> сотовой связи</span>
                      </div>
                      <div class="col-12 col-sm-8">
                        <span>Поддержка операторов <br class="d-block d-xs-none"> мобильной связи в следующих странах:​</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-lg-6">
                    <div class="row">
                      <div class="col-12">
                       <div class="rounded-4 bg-acidgreen p-4 text-dark bold-18">
                        <span>Оплата осуществляется в USDT с минимальной комиссией, обеспечивая быстрые и надежные транзакции.​</span>
                       </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>
        
          <!-- App Promo Section -->
          <section class="py-6 app-promo-section">
            <div class="container">
              <div class="card border-0 rounded-4 p-40 bg_green position-relative">
                <img src="/static/main/app/mobile.png" class="position-absolute top-50 translate-middle-y app-mobile d-none d-sm-block" width="388px">
                <div class="d-flex gap-2 align-items-center mb-2 flex-wrap w-sm-50">
                  <h2 class="mb-0 h2">Приложение — скоро!</h2>
                  <img src="/static/main/app/ant-design_apple-filled.svg" width="38" height="38">
                  <img src="/static/main/app/ant-design_android-filled.svg" width="32" height="32">
                </div>
                <div class="row mb-3 mb-sm-5">
                  <div class="col-12 col-sm-5">
                    <span>Покупать, продавать и хранить криптовалюту — будет проще и удобнее!</span>
                  </div>
                </div>
                <form class="row">
                  <div class="col-12 col-sm-7 col-md-5">
                    <input type="email" class="form-control form-control-lg mb-3" placeholder="Email" v-model='email'>
                    <button class="button myBtn rounded-pill bg-transparent acid_transparent w-100 mw-100 d-none d-sm-flex" @click="send">{{sended ? 'Отправлено' : 'Сообщите мне о запуске'}}</button>
                  </div>
                </form>
                <img src="/static/main/mobile-version/mob-xs.png" width="231" class="mx-auto d-block d-sm-none mt-3">
              </div>
              <button class="button myBtn rounded-pill bg-transparent acid_transparent w-100 mw-100 d-flex d-sm-none mx-auto mt-3" @click="send">{{sended ? 'Отправлено' : 'Сообщите мне о запуске'}}</button>
            </div>
          </section>

          <section class="py-6 consierge-section">
            <div class="container">
              <h2 class="mb-3 d-block d-md-none h2"><span class="text-green">VALUTIX</span><br> Concierge</h2>
              <div class="row align-items-center">
                <div class="col-12 col-md-7">
                  <div class="card border-0 rounded-4 p-40 mb-4 overflow-hidden">
                    <span class="spec-24">
                      24/7
                    </span>
                    <span class="bold-18">
                      Быстро, безопасно, <br> по выгодному курсу!
                    </span>
                  </div>
                </div>

                <div class="col-12 col-md-5">
                    <h2 class="mb-1 d-none d-md-block h2"><span class="text-green">VALUTIX</span> Concierge</h2>
                    <p class="mb-5 mb-sm-4">Проведём операции по покупке, продаже, обмену криптовалюты, перестановке денег, помощь при покупках в заграничных интернет магазинах через телеграмм чат</p>
                    <button class="button px-5 mw-100 w-fit myBtn bold-18 rounded-pill bg-acidgreen">
                      <span>Пишите <a href="https://t.me/Valutix_manager" target="_blank" class="bold-18 me-3 text-decoration-underline">Valutix Manager</a></span> <img src="/static/main/logos_telegram.svg" width="32px" height="32px">
                    </button>
                </div>
              </div>
             
            </div>
          </section>
    </main>
</template>

<script>
import MySwiper from "@/components/mySwiper.vue";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import Courses from "@/components/CoursesComponent.vue";
export default {
    components: {
        MySwiper,
        vSelect,
        Courses
    },
    props: ['user', 'courses'],
    data() {
        return {
            banks: [
                { image: '/static/img/banks-icons/1.svg'},
                { image: '/static/img/banks-icons/2.svg'},
                { image: '/static/img/banks-icons/3.svg'},
                { image: '/static/img/banks-icons/4.svg'},
                { image: '/static/img/banks-icons/5.svg'},
                { image: '/static/img/banks-icons/6.svg'},
                { image: '/static/img/banks-icons/7.svg'},
                { image: '/static/img/banks-icons/8.svg'},
                { image: '/static/img/banks-icons/9.svg'},
                { image: '/static/img/banks-icons/10.svg'},
                { image: '/static/img/banks-icons/11.svg'},
                { image: '/static/img/banks-icons/12.svg'},
                { image: '/static/img/banks-icons/13.svg'},
                { image: '/static/img/banks-icons/14.svg'},
                { image: '/static/img/banks-icons/15.png'},
                { image: '/static/img/banks-icons/16.png'},

            ],
            cards: [
                { image: '/static/main/card-block/1.png', desc: 'Моментальный выпуск карты Mastercard через личный кабинет.'},
                { image: '/static/main/card-block/2.png', desc: 'Привязка к Apple Pay для удобных и безопасных платежей.'},
                { image: '/static/main/card-block/3.png', desc: 'Оплата рекламы и подписок в зарубежных сервисах'},
            ],
            onRamp: true,
            isHidden: false,
            email: '',
            sended: false,
            amount: 100,
            selectedFromCurrency: 'USDT',
            selectedToCurrency: 'RUB',
            expanded: false,
            maxAmount: 999999999,
            fiatCurrencies: [
                { value: 'RUB', label: 'RUB', flag: '/img/banks/flag/RU.svg', type: 'fiat' },
                { value: 'UZS', label: 'UZS', flag: '/img/banks/flag/UZ.svg', type: 'fiat' },
                { value: 'KZT', label: 'KZT', flag: '/img/banks/flag/KZ.svg', type: 'fiat' },
                { value: 'EUR', label: 'EUR', flag: '/img/banks/flag/EU.svg', type: 'fiat' },
            ],
            cryptoCurrencies: [
                { value: 'USDT', label: 'USDT', flag: '/static/img/ico/ico-usdt.png', type: 'crypto' },
                { value: 'USDC', label: 'USDC', flag: '/static/img/ico/ico-usdc.png', type: 'crypto' },
                { value: 'BTC', label: 'BTC', flag: '/static/img/ico/ico-btc.png', type: 'crypto' },
                { value: 'ETH', label: 'ETH', flag: '/static/img/ico/ico-eth.png', type: 'crypto' },
                { value: 'TON', label: 'TON', flag: '/static/img/ico/ico-ton.png', type: 'crypto' }
            ]
        };
    },
    methods: {
      getCourse(pair) {
            let course = this.courses?.find(item => item.pair == pair);
            return (course?.rate / course?.parser?.currency_to?.delimiter) || 0;
        },
        fixedNumber(val) {
          return String(val).split('0').length - 1;
      },
        format(val) {
            return new Intl.NumberFormat('ru-RU').format(parseFloat(val).toFixed(2));
        },
        toggleCollapse() {
            this.expanded = !this.expanded;
        },
        handleExchange() {
            if (!this.user || this.user.length === 0) {
                // If user is not registered, redirect to registration
                this.$router.push('/registration');
                return;
            }

            // Find the selected currencies to determine their types
            const fromCurrency = [...this.cryptoCurrencies, ...this.fiatCurrencies].find(
                c => c.value === this.selectedFromCurrency
            );
            const toCurrency = [...this.cryptoCurrencies, ...this.fiatCurrencies].find(
                c => c.value === this.selectedToCurrency
            );

            if (!fromCurrency || !toCurrency) return;

            // If giving fiat, redirect to buy
            if (fromCurrency.type === 'fiat') {
                this.$router.push({
                    path: '/actives',
                    query: { 
                        action: 'buy',
                        currency: this.selectedToCurrency
                    }
                });
            }
            if (fromCurrency.type === 'crypto' && toCurrency.type === 'crypto') {
                this.$router.push({
                    path: '/converting',
                    query: { 
                        action: 'converting',
                        amount: this.amount,
                        currencyTo: this.selectedToCurrency,
                        currencyFrom: this.selectedFromCurrency
                    }
                });
            } 
            // If giving crypto, redirect to sell
            else if (fromCurrency.type === 'crypto') {
                this.$router.push({
                    path: '/actives',
                    query: { 
                        action: 'sell',
                        currency: this.selectedFromCurrency
                    }
                });
            }
        },
        setErrors(response) {
            const errors = response?.data?.errors || {};
            const mess = response?.data?.message || 'Что-то пошло не так';
            let text = ''
            for (const field in errors) {
                text = errors[field][0];
                break;
            }
            eventBus.$emit('errorBus', text || mess);
        },
        send(event) {
        event.preventDefault(); // Предотвращаем перезагрузку страницы
        const data = {
            email: this.email,
        };

        axios.post(this.$api_address + '/send_form/mobile_app', data)
            .then(() => {
                this.sended = true;
            })
            .catch((error) => {
                this.setErrors(error.response);
            });
    },

    // Форматирование чисел
    formatNumber(value) {
        return new Intl.NumberFormat('ru-RU').format(value);
    },
    recalculate() {
        if (!this.selectedFromCurrency || !this.selectedToCurrency || !this.amount || isNaN(this.amount)) {
            this.amountTo = 0;
            return;
        }
        const from = [...this.cryptoCurrencies, ...this.fiatCurrencies].find(c => c.value === this.selectedFromCurrency);
        const to = [...this.cryptoCurrencies, ...this.fiatCurrencies].find(c => c.value === this.selectedToCurrency);
        const direct = this.courses.find(item => item.pair === `${this.selectedToCurrency}-${this.selectedFromCurrency}`);
        if (!direct) {
            this.amountTo = 0;
            return;
        }
        const rate = direct.rate / (direct.parser?.currency_to?.delimiter || 1);
        if (from && to && from.type === 'fiat' && to.type === 'crypto') {
            this.amountTo = (this.amount * (1 / rate)).toFixed(6);
            return;
        }
        this.amountTo = (this.amount * rate).toFixed(6);
    },
    swapCurrencies() {
      const tmp = this.selectedFromCurrency;
      this.selectedFromCurrency = this.selectedToCurrency;
      this.selectedToCurrency = tmp;
    },
    onAmountInput(event) {
      if (this.amount > this.maxAmount) {
        this.amount = this.maxAmount;
      }
      if (this.amount < 0) {
        this.amount = 0;
      }
    },
    },
    computed: {
      BTC2USDT() {
            return this.getCourse(`BTC-USDT`);
        },
        //Покупка
        USDT2KZT() {
            return this.getCourse(`USDT-KZT`);
        },
        BTC2RUB() {
            return this.getCourse(`BTC-RUB`);
        },
        BTC2KZT() {
            return this.getCourse(`BTC-KZT`);
        },
        BTC2UZS() {
            return this.getCourse(`BTC-UZS`);
        },
        USDT2UZS() {
            return this.getCourse(`USDT-UZS`);
        },
        USDT2RUB() {
            return this.getCourse(`USDT-RUB`);
        },
        USDT2EUR() {
            return this.getCourse(`USDT-EUR`);
        },
        BNB2USDT() {
            return this.getCourse(`BNB-USDT`);
        },
        ETH2USDT() {
            return this.getCourse(`ETH-USDT`);
        },
        LTC2USDT() {
            return this.getCourse(`LTC-USDT`);
        },
        TON2USDT() {
            return this.getCourse(`TON-USDT`);
        },
        //Продажа
        RUB2USDT() {
            return this.getCourse(`RUB-USDT`);
        },
        RUB2BTC() {
            return this.getCourse(`RUB-BTC`);
        },
        KZT2BTC() {
            return this.getCourse(`KZT-BTC`);
        },
        UZS2BTC() {
            return this.getCourse(`UZS-BTC`);
        },
        KZT2USDT() {
            return this.getCourse(`KZT-USDT`);
        },
        UZS2USDT() {
            return this.getCourse(`UZS-USDT`);
        },
        EUR2USDT() {
            return this.getCourse(`EUR-USDT`);
        },
        BTC2USDT_upd() {
            return this.courses?.find(item => item.pair == `BTC-USDT`)?.updated_at;
        },
        fiatPairs() {
            return [
                { label: 'RUB', buy: this.USDT2RUB, sell: this.RUB2USDT },
                { label: 'KZT', buy: this.USDT2KZT, sell: this.KZT2USDT },
                { label: 'UZS', buy: this.USDT2UZS, sell: this.UZS2USDT },
                { label: 'EUR', buy: this.USDT2EUR, sell: this.EUR2USDT },
            ];
        },
        cryptoPairs() {
            return [
                { label: 'ETH', value: this.ETH2USDT },
                { label: 'BNB', value: this.BNB2USDT },
                { label: 'LTC', value: this.LTC2USDT },
                { label: 'TON', value: this.TON2USDT },
            ];
        },
        duplicatedCards() {
          return [...this.banks, ...this.banks]; // удваиваем элементы для плавной бесконечности
        },
        // Опции для первого селекта (Отдаю)
        fromOptions() {
            // В первом селекте показываем все валюты
            return [...this.cryptoCurrencies, ...this.fiatCurrencies];
        },
        // Опции для второго селекта (Получаю)
        toOptions() {
            if (!this.selectedFromCurrency) {
                return [];
            }
            
            // Находим выбранную валюту
            const selectedCurrency = [...this.cryptoCurrencies, ...this.fiatCurrencies].find(
                c => c.value === this.selectedFromCurrency
            );
            
            if (!selectedCurrency) {
                return [];
            }

            // Если выбрана фиатная валюта в первом селекте
            if (selectedCurrency.type === 'fiat') {
                // Показываем только криптовалюты
                return this.cryptoCurrencies;
            }
            
            // Если выбрана криптовалюта в первом селекте
            // Показываем все валюты, кроме выбранной криптовалюты
            return [...this.cryptoCurrencies, ...this.fiatCurrencies].filter(
                c => c.value !== this.selectedFromCurrency
            );
        },
            // Получаем курс для выбранной пары валют
    currentRate() {
        if (!this.selectedFromCurrency || !this.selectedToCurrency) return 0;
        const from = [...this.cryptoCurrencies, ...this.fiatCurrencies].find(c => c.value === this.selectedFromCurrency);
        const to = [...this.cryptoCurrencies, ...this.fiatCurrencies].find(c => c.value === this.selectedToCurrency);
        const direct = this.courses?.find(item => item.pair === `${this.selectedToCurrency}-${this.selectedFromCurrency}`);
        if (!direct) return 0;
        const rate = direct.rate / (direct.parser?.currency_to?.delimiter || 1);
        // Если отдаём фиат, получаем крипто — используем обратный курс
        if (from && to && from.type === 'fiat' && to.type === 'crypto') {
            return 1 / rate;
        }
        if (from && to && from.type === 'crypto' && to.type === 'crypto') {
            return 1 / rate;
        }
        return rate;
    },
  },
  watch: {
    selectedFromCurrency() {
        // Получаем доступные опции для второго селектора
        const availableOptions = this.toOptions;
        // Если текущая выбранная валюта справа отсутствует в доступных опциях — меняем на первую
        if (!availableOptions.find(opt => opt.value === this.selectedToCurrency)) {
            if (availableOptions.length > 0) {
                this.selectedToCurrency = availableOptions[0].value;
            }
        }
        this.recalculate();
    },
    selectedToCurrency(newValue) {
        // Если значение сбросилось (стало null или undefined)
        if (!newValue) {
            const availableOptions = this.toOptions;
            if (availableOptions.length > 0) {
                this.selectedToCurrency = availableOptions[0].value;
            }
        }
        this.recalculate();
    },
    amount() {
        this.recalculate();
    },
  },
}
</script>

<style scoped>
/* Существующие стили */
* {
  background-repeat: no-repeat;
}

/* Стили для vue-select */
:deep(.v-select) {
  background: transparent;
}

:deep(.vs__dropdown-toggle) {
  background: transparent;
  border: 1px solid #7D8983;
  border-radius: 8px;
  padding: 4px 8px;
  min-height: 40px;
}

:deep(.vs__selected) {
  color: white;
  margin: 0;
  padding: 0;
}

:deep(.vs__search) {
  display: none;
}

:deep(.vs__dropdown-menu) {
  background: #293B33;
  border: 1px solid #7D8983;
  border-radius: 8px;
  margin-top: 4px;
  padding: 4px 0;
  height: 200px;
}

:deep(.vs__dropdown-option) {
  color: white;
  padding: 8px 12px;
  align-items: center;
  gap: 8px;
}

:deep(.vs__dropdown-option--highlight) {
  background: rgba(105, 226, 120, 0.1);
  color: #69E278;
}

:deep(.vs__open-indicator) {
  fill: rgba(255, 255, 255, 0.5);
}

:deep(.vs__clear) {
  fill: rgba(255, 255, 255, 0.5);
}

:deep(.vs__selected-options) {
  padding: 0;
  display: flex;
  align-items: center;
}

:deep(.vs__actions) {
  padding: 0;
}

:deep(.vs__selected) {
  display: flex;
  align-items: center;
  gap: 8px;
}

.currency-pair .text-success {
  min-width: 100px;
}

.arrow {
  transition: transform 0.3s;
}
[aria-expanded="true"] .arrow {
  transform: rotate(180deg);
}

.border-opacity-green {
  border: 1px solid #7D8983;
}

/* Остальные существующие стили */
.gradient-text {
  color: transparent;
  background: linear-gradient(90deg, #5C5C5C -2.33%, #FFF 32.1%, #FFF 61.94%, #5C5C5C 99.66%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

h1 {
  line-height: 91.3%;
}

h2 {
  font-size: 40px;
  font-weight: 800;
}

.myBtn, .myBtn a {
  color: #212121 !important;
  text-align: center;
  font-family: Montserrat;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: normal;
}

.acid_border {
  border: 1px solid #69E278 !important;
}

.acid_text {
  color: #69E278 !important;
}

.myBtn.acid_transparent {
  border: 1px solid #69E278 !important;
  color: #69E278 !important;
  background-color: transparent !important;
}

.py-6 {
  padding-top: 80px;
  padding-bottom: 80px;
}

.change_block {
  backdrop-filter: blur(25.850000381469727px);
  background: rgba(53, 99, 79, 0.40);
}

.change_block_inner {
  margin-bottom: 86px;
}

.first-screen {
  background-image: url('/public/static/main/first-screen.png');
  background-size: auto;
  background-position: center 10%;
  padding-bottom: 60px;
  padding-top: 20px;
}

.second-screen {
  background-image: url('/public/static/main/card-block/bg.png');
  background-size: 100% 100%;
  background-position: center;
  padding: 68px 0 107px 0;
}

.on-ramp-section img {
  width: 100%;
  height: 100%;
}

.app-promo-section .card {
  background-image: url('/public/static/main/app/bg.png');
  background-position: center right;
  background-size: contain;
}

.about-card-section .card {
  padding: 48px 40px 33px;
  height: 368px;
}

.about-card {
  background-color: rgba(53, 99, 79, 1);
  background-image: url('/public/static/main/bg-about-card.png');
  background-size: 100% 100%;
  background-position: center;
}

.about-card-2 {
  background-color: rgba(53, 99, 79, 0.2);
  background-image: url('/public/static/main/bg-about-card-2.png');
  background-size: cover;
  background-position: center;
}

.marquee-container {
  overflow: hidden;
  width: 100%;
}

.marquee-track {
  display: flex;
  width: fit-content;
  gap: 24px;
  animation: marquee 60s linear infinite;
}

.marquee-track-reverse {
  display: flex;
  width: fit-content;
  gap: 24px;
  animation: marquee-reverse 60s linear infinite;
}

.marquee-item {
  width: 196px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #35634F;
  border-radius: 20px;
  overflow: hidden;
}

.marquee-item img {
    max-height: 50px;
    object-fit: contain;
}

.section-cards {
  margin-bottom: 70px;
}

.section-cards .card {
  height: 300px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
}

.coming-section .card {
  height: 350px;
  background-position: bottom right;
  background-size: 100% 100%;
}

.bg_darkgreen {
  background-color: #293B33;
}

.under {
  background-color: #69E278;
  height: 8px;
  width: 100%;
}

.text-green {
  -webkit-text-fill-color: #69E278;
}

.p-40  {
  padding: 40px;
}

.card-img {
  width: 100%;
}

.bold-18, .myBtn .bold-18 {
  font-weight: 600 !important;
  font-size: 18px !important;
}

.bold-500-18 {
  font-weight: 500;
  font-size: 18px;
}

.app-mobile {
  right: 55px;
  max-width: 100%;
}

.consierge-section .card {
  height: 380px;
  background-image: url('/public/static/main/consierge.jpg');
  background-position: bottom right;
  background-size: 100% 100%;
}

.spec-24 {
  color: #69E278;
  font-size:calc(66px + 37 * (100vw - 320px) / 800);
  font-weight: 700;
}

.px-6 {
  padding-right: 60px;
  padding-left: 60px;
}

.fw-extrabold {
  font-weight: 900;
}

.coming-section-item-1 {
   background-image: url('/public/static/main/coming-soon/1.png')
}
.coming-section-item-2 {
  background-image: url('/public/static/main/coming-soon/2.png')
}
.coming-section-item-3 {
  background-image: url('/public/static/main/coming-soon/3.png')
}

.coming-section {
  background-image: url('/public/static/main/coming-soon/bg.png');
  background-position: top -300px center;
  background-size: contain;
}

.shop-block {
  background-image: url('/public/static/main/coming-soon/block-bg.png');
  background-position: center;
  background-size: 100% 100%;
}

.how-card {
  backdrop-filter: blur(24px);
}

@media (max-width: 1200px) {
  .w-sm-50 {
    width: 50%;
  }
  .w-mob-100 {
    width: 100% !important;
  }
  .change_block_inner .input-group,
  .change_block_inner :deep(.v-select) {
    width: 179px;
    box-sizing: border-box;
  }
}

@media (max-width: 1024px) {
  .p-40 {
    padding: 35px;
  }
  .app-mobile {
    width: 200px;
  }
}

@media (max-width: 992px) {
  .coming-section {
    background-image: url('/public/static/main/mobile-version/bg.png');
    background-position: top -300px center;
    background-size: 100% 100%;
  }

  .change_block {
    margin-top: 22px;
  }
}

@media (max-width: 768px) {
  .p-40 {
    padding: 30px;
  }
  .py-6 {
    padding-top: 55px;
    padding-bottom: 55px;
  }
  .little-h2 {
    font-size: 20px;
  }

  .first-screen {
    padding-top: 10px;
  }
}

@media (max-width: 576px) {
  .p-40 {
    padding: 20px;
  }
  .first-screen {
    background-image: url('/public/static/main/mobile-version/first-bg.png');
    background-size: 771px 880px;
    background-position: top -300px right -200px;
    padding-bottom: 0;
  }

  .mb-big {
    margin-bottom: 155px !important;
  }

  h2 {
    font-size: 30px;
    margin-bottom: 13px;
  }

  .span {
    font-size: 14px;
    line-height: normal;
  }

  .title-section {
    padding-bottom: 10px;
  }

  .swiper-section {
    padding-bottom: 0;
  }

  .banks-section {
    background-image: url('/public/static/main/mobile-version/bank-bg.png');
    background-size: 722px 723px;
    background-position: center;
    padding-top: 90px;
    padding-bottom: 110px;
  }

  .second-screen {
    background-image: url('/public/static/main/mobile-version/second-screen.png');
    padding: 38px 0 77px;
  }

  .about-card-section {
    padding-top: 110px;
  }

  .about-card-section .card {
    padding: 30px 20px;
  }

  .about-card-section .card:has(.card-img) {
    height: fit-content;
  }

  .little-h2 {
    font-size: 14px;
  }

  .display-1 {
    font-size: 30px;
  }

  .w-sm-50 {
    width: 100%;
  }

  .consierge-section .card {
    height: fit-content;
  }

  .coming-section-item-1 {
    background-image: url('/public/static/main/mobile-version/3.png')
 }
 .coming-section-item-2 {
   background-image: url('/public/static/main/mobile-version/1.png')
 }
 .coming-section-item-3 {
   background-image: url('/public/static/main/mobile-version/2.png')
 }

 .coming-section-item-2 .badge {
  font-size: 11px !important
 }

 .coming-section .card {
  background-color: rgba(53, 99, 79, 0.5) !important;
 }

 .app-promo-section .card{
  background-position: center left;
  background-size: cover;
 }

 .mb-big {
  margin-bottom: 84px !important;
 }

 .myBtn {
  width: 100% !important;
 }

}

@media (max-width: 420px) {
/*  .title-section {
    padding-top: 92px !important;
  }*/
  :deep(.vs__selected) {
    font-size: 12px;
  }
}

@media (max-width: 375px) {
  .section-cards .card {
    height: 260px;
  }
}

@media (max-width: 320px) {
  .section-cards .card {
      height: 245px;
  }
}

/* Ключевая анимация движения */
@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@keyframes marquee-reverse {
  0% {
    transform: translateX(-50%);
  }
  100% {
    transform: translateX(0);
  }
}

/* Убираем стрелки у input type="number" */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.exchange-info {
  line-height: 1.4;
}

.exchange-info .small {
  font-size: 12px;
}

.change_block_inner :deep(.v-select) {
  width: 100%;
  min-width: 115px;
  max-width: 179px;
  box-sizing: border-box;
}

.change_block_inner .input-group {
  width: 100%;
  box-sizing: border-box;
}

.change_block {
  padding: 22px 19px;
}

@media (min-width: 768px) {
  .change_block_inner :deep(.v-select) {
    width: 100%;
    box-sizing: border-box;
  }
  .change_block {
    padding: 30px 34px;
  }
}

.input-group .form-control {
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-color: #7D8983;
}

.input-group .input-group-text {
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  background: transparent;
  color: #b0bfc7;
  border-color: #7D8983;
}

.courses-toggle {
  cursor: pointer;
  font-size: 10px;
}
.courses-updated {
  color: rgba(255, 255, 255, 0.7);
}
.currency-pair, .crypto-rate {
  border-bottom: 1px solid #7D8983;
  font-size: 14px;
}
.pair-header {
  color: #fff;
  font-size: 16px;
}
.rates {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.text-success {
  color: #74ED79 !important;
}
.text-danger {
  color: #FF6D6D !important;
}
.courses-expanded {
  width: fit-content;
  background: rgba(53, 99, 79, 0.40);
  backdrop-filter: blur(23px);
  padding: 18px 28px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.w-40 {
  width: 50px;
}
.fz-14 {
  font-size: 14px;
}
.fz-16 {
  font-size: 16px;
}
.green_border {
  border: 1px solid #35634F;
  border-radius: 5;
}
.fw-300 {
  font-weight: 300;
}
.green_bg {
  background-color: #35634F;
}
#courses_block {
  margin-top: 76px;
}
.brs-5 {
  border-radius: 5px;
}

.btn-primary {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  gap: 5px;
  background: #4AA485;
  min-width: 268px;
  margin-left: auto;
  outline: 0;
  border: 0;
}
.btn-primary span{
  display: block;
}
.btn-primary:hover {
  background: #4AA485;
}
.btn-primary[aria-expanded = "true"] .arrow {
  transform: rotate(180deg);
}
.courses_title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.courses_line {
  font-size: 16px;
}
@media(max-width:992px) {
  .btn-primary {
      width: 100%;    
  }
  .courses_wrap {
      padding-top: 8px;
      padding-bottom: 8px;
  }

  .change_block_inner :deep(.v-select) {
    width: 100%;
    max-width: 100%;
  }
}
@media(max-width:768px) {
  .courses_wrap {
      gap: 0;
  }
  .courses_wrap_item .fz-16{
      font-size: 12px !important;
  }
}
@media(max-width:576px) {
  .courses_wrap_item .fz-16{
      font-size: 11px !important;
  }
  .mob-curses {
    font-size: 9px;
  }
}
@media(max-width: 425px) {
  #courses_block {
    margin-top: 53px;
  }
}
@media(max-width: 375px) {
  .courses_line {
      font-size: 12px;
      font-weight: 300;
  }

  .courses_wrap_item .fz-16 {
    font-size: 9px !important;
  }
  .change_block_inner .v-select {
    min-width: unset;
  }

  .mine-title {
    font-size: 25px !important;
  }

}

@media(max-width: 340px) {
  .mob-curses {
    font-size: 8px;
  }
}

@media(max-width: 320px) {
  #courses_block .container {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

.exchange-eq {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  word-break: break-word;
}
.exchange-left {
  white-space: nowrap;
}
.exchange-right {
  white-space: nowrap;
}

</style>
